import React from "react";
import { IconButton } from "@material-tailwind/react";
import {
  ChevronLeftIcon,
  ChevronRightIcon
} from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";


export function Pagination({ currentPage, itemsPerPage = 10, setCurrentPage, setItemsPerPage, totalPages }) {

  const { t } = useTranslation("common");

  return (
    <div className="flex items-center flex-wrap justify-between md:justify-start p-4 gap-x-8 gap-y-4">
      <div className="flex items-center gap-2">
        <IconButton
          variant="outlined"
          color="blue-gray"
          className="rounded-md"
          onClick={() => {
            const next_page = Math.max(currentPage - 1, 1);
            setCurrentPage(next_page);
          }}
          disabled={currentPage === 1}
        >
          <ChevronLeftIcon className="h-5 w-5" />
        </IconButton>

        <IconButton
          variant="outlined"
          color="blue"
          className="rounded-md cursor-default"
          disabled
        >
          {currentPage}
        </IconButton>

        <IconButton
          variant="outlined"
          color="blue-gray"
          className="rounded-md"
          onClick={() => {
            const next_page = Math.min(currentPage + 1, totalPages);
            setCurrentPage(next_page);
          }}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <ChevronRightIcon className="h-5 w-5" />
        </IconButton>
      </div>
      <div className="flex items-center gap-x-2 text-sm text-gray-600">
        <select
          value={itemsPerPage}
          onChange={(e) => {
            setItemsPerPage(Number(e.target.value));
            setCurrentPage(1);
          }}
          className="border border-gray-300 rounded-md p-2 focus:outline-none bg-gray-100 w-36"
        >
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
        </select>
        <span>/ {t("page")}</span>
      </div>
    </div>
  );
}

export default Pagination;
